module["exports"] = [
  "پس انداز",
  "سرمایه گذاری",
  "وام مسکن",
  "کارت اعتباری",
  "وام خودرو",
  "وام شخصی"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/finance/account_type.js
// module id = 2936
// module chunks = 1610